if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    /**
     * Initializes the Stick ATC component.
     */
    constructor() {
      super();

      this.ACTIVE_CLASS = "sticky-add-to-cart--active";
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     */
    connectedCallback() {
      window.addEventListener("scroll", () => this.onScroll(), { passive: true });
      this.onScroll();
    }

    /**
     * Handles showing ATC on scroll if triggerElement out of view
     */
    onScroll() {
      const elementBot = this.triggerElement.getBoundingClientRect().bottom;
      const showATC = elementBot < 0;

      showATC
        ? this.classList.add(this.ACTIVE_CLASS)
        : this.classList.remove(this.ACTIVE_CLASS);
    }

    /**
     * Returns the trigger for when the sticky add should show
     */
    get triggerElement() {
      return document.querySelector("[data-add-to-cart]");
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}